import { ref } from 'vue'
import { defineStore } from 'pinia'
import { fetchLogosFooterApi, fetchUrlsFooterApi } from '@/service'

export const useFooterStore = defineStore('footer', () => {

  const footerLogos = ref({})
  // const programItems = computed(() => programs.value?.items ?? [])
  const  footerUrls = ref({})

  const fetchFooterLogos = () => {
    return fetchLogosFooterApi().then((response) => {
      footerLogos.value = response
      return Promise.resolve(response)
    })
  }

  const fetchFooterUrls = async () => {
    return fetchUrlsFooterApi().then((response) => {
      footerUrls.value = response
      return Promise.resolve(response)
    })
  }

  return {
    footerLogos,
    // programItems,
    footerUrls,
    fetchFooterLogos,
    fetchFooterUrls
  }
})
